function initializeMagnesioTabs(scope=document){
  scope.querySelectorAll('[data-mg-tabs]').forEach(section=>{
    if(section.dataset.tabsReady)return;
    section.dataset.tabsReady='true';
    const tabs=Array.from(section.querySelectorAll('[role="tab"]'));
    const panels=Array.from(section.querySelectorAll('[role="tabpanel"]'));
    function selectTab(tab,focus=false){
      tabs.forEach(item=>{const selected=item===tab;item.setAttribute('aria-selected',String(selected));item.tabIndex=selected?0:-1;});
      panels.forEach(panel=>{panel.hidden=panel.id!==tab.getAttribute('aria-controls');});
      if(focus)tab.focus();
    }
    tabs.forEach((tab,index)=>{
      tab.addEventListener('click',()=>selectTab(tab));
      tab.addEventListener('keydown',event=>{
        let next=index;
        if(event.key==='ArrowRight')next=(index+1)%tabs.length;
        else if(event.key==='ArrowLeft')next=(index+tabs.length-1)%tabs.length;
        else if(event.key==='Home')next=0;
        else if(event.key==='End')next=tabs.length-1;
        else return;
        event.preventDefault();selectTab(tabs[next],true);
      });
    });
  });
}
initializeMagnesioTabs();
document.addEventListener('shopify:section:load',event=>initializeMagnesioTabs(event.target));
